import React from 'react';
import styles from './common.scss';

export default function FieldLabel({ error, label, style }) {
  const cl = [styles.label];
  if (error) cl.push(styles.error);
  
  return <small className={cl.join(' ')} style={style}>{label}</small>;
}
